import React from "react";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import { styled } from "@mui/material/styles";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Styles for the Popup overlay
const Overlay = styled("div")({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
});

// Styles for the Popup container
const PopupContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.borders.borderRadius.md,
  boxShadow: theme.shadows[5],
  width: "600px",
  padding: theme.spacing(2, 4, 3),
  position: "relative",
}));

// Styles for the Close Button
const CloseButton = styled(MDButton)({
  position: "absolute",
  top: "8px",
  right: "8px",
  fontsize: "20px",
  minWidth: "auto",
  padding: "8px",
});

// Styles for the Footer with Buttons
const Footer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  marginTop: "20px",
});

function AddBuyerPopup({ content, handleContent, buttonSpeichern, buttonAbbrechen }) {
  return (
    <Overlay>
      <PopupContainer>
        {/* <CloseButton onClick={onSave}>×</CloseButton> */}
        <div>
          <h3>Käufer hinzufügen</h3>
          <MDBox>
            <MDBox mt={2} mb={3} display="flex" flexDirection="row" alignItems="center" gap={2}>
              <MDTypography variant="body2" component="p" color="text">
                Vorname:
              </MDTypography>
              <MDInput
                value={content.firstName}
                onChange={(e) => handleContent(e, "firstName")}
                style={{
                  minWidth: "300px",
                  maxWidth: "300px"
                }}
              />
            </MDBox>
            <MDBox mt={2} mb={3} display="flex" flexDirection="row" alignItems="center" gap={2}>
              <MDTypography variant="body2" component="p" color="text">
                Nachname:
              </MDTypography>
              <MDInput
                value={content.lastName}
                onChange={(e) => handleContent(e, "lastName")}
                style={{
                  minWidth: "300px",
                  maxWidth: "300px"
                }}
              />
            </MDBox>
            <MDBox mt={2} mb={3} display="flex" flexDirection="row" alignItems="center" gap={2}>
              <MDTypography variant="body2" component="p" color="text">
                E-Mail:
              </MDTypography>
              <MDInput
                value={content.email}
                onChange={(e) => handleContent(e, "email")}
                style={{
                  minWidth: "300px",
                  maxWidth: "300px"
                }}
              />
            </MDBox>
            <MDBox mt={2} mb={3} display="flex" flexDirection="row" alignItems="center" gap={2}>
              <MDTypography variant="body2" component="p" color="text">
                Telefon:
              </MDTypography>
              <MDInput
                value={content.phone}
                onChange={(e) => handleContent(e, "phone")}
                style={{
                  minWidth: "300px",
                  maxWidth: "300px"
                }}
              />
            </MDBox>
          </MDBox>
          <Footer>
            <MDButton variant="gradient" color="dark" onClick={buttonSpeichern}>Speichern</MDButton>
            <MDButton variant="gradient" color="dark" onClick={buttonAbbrechen}>Abbrechen</MDButton>
          </Footer>
        </div>
      </PopupContainer>
    </Overlay>
  );
}

// Setting default values for the props of AddBuyerPopup
AddBuyerPopup.defaultProps = {
  title: "Title",
  content: "Content Content Content Content Content Content ",
  onClose: () => {},
  onSave: () => {},
};

// Typechecking props of the AddBuyerPopup
AddBuyerPopup.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};

export default AddBuyerPopup;